import {ToggleButton} from '@wandb/components';
import React, {useCallback} from 'react';

import {trackPanelBankEvent} from '../../services/analytics';
import type * as PanelBankSectionConfigTypes from '../../state/views/panelBankSectionConfig/types';

type PinSectionButtonProps = {
  pinPanelBankSection?: (sectionId: PanelBankSectionConfigTypes.Ref) => void;
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref;
  isPinned: boolean;
};

export const PinSectionButton = ({
  pinPanelBankSection,
  panelBankSectionConfigRef,
  isPinned,
}: PinSectionButtonProps) => {
  const onClick = useCallback(() => {
    const isPinnedMemo = isPinned;
    pinPanelBankSection?.(panelBankSectionConfigRef);
    /*
     * if isPinnedMemo (previous state) is true, the new state is false
     * so we track the 'pin' action, and vice versa
     */
    trackPanelBankEvent({
      action: isPinnedMemo
        ? 'Unpin panel bank section'
        : 'Pin panel bank section',
    });

    if (!isPinnedMemo) {
      window.scrollTo(0, 0);
    }
  }, [isPinned, panelBankSectionConfigRef, pinPanelBankSection]);

  return (
    <ToggleButton
      variant="pin"
      isSelected={isPinned}
      tooltip={{children: 'Pin section', placement: 'bottom'}}
      aria-label="Pin section"
      onPress={onClick}
    />
  );
};
